import { Icon, IconsEnum } from 'components/Icons';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import classNames from 'classnames';
import { setIsInfoOpen } from 'features/sport/sportSlice';
import styles from './SportResultsAndInfoTrigger.module.scss';
import { selectIsInfoOpen } from 'features/sport';
import { AppFragment } from 'enums/path-fragment';
import { useIsPageOfType } from 'features/sport/hooks';

export type SportResultsAndInfoTriggerProps = {
  className?: string;
};

export const SportResultsAndInfoTrigger = ({ className }: SportResultsAndInfoTriggerProps) => {
  const dispatch = useAppDispatch();
  const isLive = useIsPageOfType(AppFragment.Live);
  const isInfoOpen = useTypedSelector(selectIsInfoOpen);

  return (
    <button
      type="button"
      className={classNames(
        styles.button,
        {
          [styles.open]: isInfoOpen,
          [styles.liveColor]: isLive,
        },
        className ?? ''
      )}
      onClick={() => dispatch(setIsInfoOpen(!isInfoOpen))}
    >
      <Icon
        key={`stats-${isInfoOpen}`}
        iconId={IconsEnum.STATS}
        className={classNames(styles.icon)}
        color={`var(--color-${isInfoOpen ? 'surface-01' : 'on-bg-primary'})`}
      />
    </button>
  );
};
